<template>
  <div>
    <h3>Insider server info</h3>

    <template v-if="info !== null">
      <table class="props-compact mb-4">
        <tr>
          <th>Time</th>
          <td>{{info.time | getMomentStr}}</td>
        </tr>
        <tr>
          <th>constant.GAME_VERSION</th>
          <td>{{info.gameVersion}}</td>
        </tr>
        <tr>
          <th>constant.GAME_REVISION_HASH</th>
          <td>{{info.revisionHash}}</td>
        </tr>
        <tr>
          <th>constant.IS_DEV</th>
          <td>{{info.isDev}}</td>
        </tr>
        <tr>
          <th>Runtime version</th>
          <td>{{info.runtimeVersion}}</td>
        </tr>
        <tr>
          <th>Hostname</th>
          <td>{{info.hostname}}</td>
        </tr>
        <tr>
          <th>Scheduler hostname</th>
          <td>{{info.schedulerHostname}}</td>
        </tr>
        <tr>
          <th>Redis version</th>
          <td>{{info.redisVersion}}</td>
        </tr>
        <tr>
          <th>Push service URL</th>
          <td>{{info.pushdURL}}</td>
        </tr>
        <tr>
          <th>ConfMgr version</th>
          <td>{{info.confMgrPathVersion}} (bundle: {{info.confMgrBundleVersion}})</td>
        </tr>
      </table>

      <hr>

      <h4 class="mb-1">Uptrace conf</h4>
      <table class="props-compact mb-4">
        <tr>
          <th>Uptrace on</th>
          <td>{{info.uptraceInfo.uptraceOn}}</td>
        </tr>
        <tr>
          <th>Uptrace DSN</th>
          <td>{{info.uptraceInfo.uptraceDSN}}</td>
        </tr>
        <tr>
          <th>Service name</th>
          <td>{{info.uptraceInfo.serviceName}}</td>
        </tr>
        <tr>
          <th>Service version</th>
          <td>{{info.uptraceInfo.serviceVersion}}</td>
        </tr>
        <tr>
          <th>Environment</th>
          <td>{{info.uptraceInfo.deploymentEnvironment}}</td>
        </tr>
      </table>

      <hr>

    </template>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

import LoadingIndicator from './LoadingIndicator.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'SystemInfoInsiderServer',

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      info: null,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },
  },

  created() {
    this.loadInfo();
  },

  methods: {
    loadInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      HTTP.get('/insider_server_info')
      .then(response => {
        this.info = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
